import { useContext } from 'react';
import { AuthContext } from "../../contexts/auth";
import { useNavigate } from 'react-router-dom';
import './clienteSelecionado.css';

const ClienteSelecionado = () => {
  const { clientes, loadClientSelected, clientSelected } = useContext(AuthContext);
  const navigate = useNavigate();

  function handleChangeCliente (e) {
    // console.log("e.target.value cliente: ", e.target.value)
    if (e.target.value) {
      loadClientSelected(e.target.value);
      navigate('/principal');
    }
  };

  return (
    <div>
      <div className="combo-container">
        <span>
          <label className="combo-label">Cliente: </label>
          <select className="combo-select" value={clientSelected} onChange={handleChangeCliente} >
            <option key='0' value=''>Selecione um Cliente</option>
            {clientes.map((item, index) => {
              return(
                <option key={item.cod_cliente} value={index}>
                  {item.idt_cliente} - {item.nom_cliente}
                </option>
              )
            })}
          </select>
        </span>
      </div>
    </div>
  )
}
export default ClienteSelecionado;
